import { Link } from "react-router";

export const rowActionIcons = {
	view: "icon-eye",
	status: "icon-info-new",
	sendToProcessing: "icon-chevrons-right",
	delete: "icon-admin-delete",
	retry: "icon-admin-syc",
	reset: "icon-back",
	revoke: "icon-cancel-circle",
	editName: "icon-crayon",
} as const;

interface RowActionProps {
	icon: string;
	label: string;
}

export function RowActionLink({ icon, label, to }: RowActionProps & { to: string }) {
	return (
		<Link className="actionsIconButton" to={to} title={label} aria-label={label}>
			<span className={`icon-new icon-white ${icon} icon-16`} />
		</Link>
	);
}

interface RowActionButtonProps extends RowActionProps {
	onClick: () => void;
	disabled?: boolean;
	disabledReason?: string;
}

export function RowActionButton({ icon, label, onClick, disabled = false, disabledReason }: RowActionButtonProps) {
	const button = (
		<button className="actionsIconButton" type="button" onClick={onClick} disabled={disabled} title={label} aria-label={label}>
			<span className={`icon-new icon-white ${icon} icon-16`} />
		</button>
	);

	if (disabled === false) {
		return button;
	}

	// A disabled button takes no pointer events, so its own tooltip never opens: the wrapper is what
	// the pointer hovers.
	return (
		<span className="actionsIconButton-disabledWrap" title={disabledReason ?? label}>
			{button}
		</span>
	);
}
